/*eslint-disable*/
import React from "react";
import SelectInput from "../../components/select_input/SelectInput";
import { Link } from "react-router-dom";

const ScorecardBoost = ({
    selectedApp,
    showBusinessVideoTooltip, setShowBusinessVideoTooltip,
    showBusinessPlanTooltip, setShowBusinessPlanTooltip,
    showLocationUsageTooltip, setShowLocationUsageTooltip,
    showBreakevenPointTooltip, setShowBreakevenPointTooltip,
    showChallengeTooltip, setShowChallengeTooltip,
    showPlanHireTooltip, setShowPlanHireTooltip,
    showOverallImpactTooltip, setShowOverallImpactTooltip,
    showMembersAwardedTooltip, setShowMembersAwardedTooltip,
    handleChange,
    scorecardOPTIONS,
    orgAmountOPTIONS,
    handleAnnualAward,
    amount
}) => {
    return (
        <div className="mt-6 mb-4 w-full space-y-6 bg-gray-50 p-6 rounded-lg shadow-md">

            {/* Business Video*/}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm mb-7">
                <label
                    htmlFor="businessVideo"
                    className="text-lg font-semibold text-gray-800 block mb-2"
                >
                    Record a Business Video (3 minutes or less)
                </label>
                <div className="mt-1">
                    {selectedApp?.businessVideo && selectedApp?.businessVideo !== "N/A" ? (
                        <Link
                            className="underline text-blue-600 hover:text-blue-800 transition"
                            to={selectedApp.businessVideo}
                            target="_blank"
                        >
                            {selectedApp.businessVideo}
                        </Link>
                    ) : (
                        <span className="text-gray-600">
                            No business video available for this application.
                        </span>
                    )}
                </div>
                <label
                    htmlFor="scoreBusinessVideo"
                    className="block text-md font-semibold text-gray-800 mb-2 relative mt-4"
                >
                    Business Video Score (0 OR 3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowBusinessVideoTooltip(true)}
                    >
                        ?
                    </button>
                    {showBusinessVideoTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowBusinessVideoTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">
                                Business Video Score Guide:
                            </h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "No video submitted.",
                                    },
                                    {
                                        score: 3,
                                        text: "Thorough video presenting a clear narrative of the business.",
                                    },
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>

                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS.filter(
                        (option) => option.value === 0 || option.value === 3
                    )} // Filter to show only 0 and 3
                    placeholder={
                        selectedApp?.scoreBusinessVideo != null
                            ? selectedApp.scoreBusinessVideo
                            : "Select a score"
                    }
                    defaultValue={
                        selectedApp?.scoreBusinessVideo != null
                            ? selectedApp.scoreBusinessVideo
                            : undefined
                    }
                    setSelectedValue={(evt) => handleChange("scoreBusinessVideo", evt.value)}
                />
            </div>
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Business Overview</h2>
            {/* Tell Us About Your Business Plan */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="businessPlan"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    Tell Us About Your Business Plan:
                </label>
                <textarea
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 text-gray-700 bg-gray-100"
                    defaultValue={selectedApp?.businessPlan}
                    rows="4"
                />
                <label
                    htmlFor="scoreBusinessPlan"
                    className="block text-md font-semibold text-gray-800 mb-2 relative"
                >
                    Business Plan Score (0-3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowBusinessPlanTooltip(true)}
                    >
                        ?
                    </button>
                    {showBusinessPlanTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowBusinessPlanTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Business Plan Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "Very little or no information provided about the business; lacks clarity and purpose."
                                    },
                                    {
                                        score: 1,
                                        text: "Partial or vague description of the business, missing key elements such as goals or target audience."
                                    },
                                    {
                                        score: 2,
                                        text: "Good description, with most essential elements (goals, target market) covered, but lacking some depth or clarity."
                                    },
                                    {
                                        score: 3,
                                        text: "Thorough description of the business, including clear goals, target market, value proposition, and operational plan."
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS}
                    placeholder={
                        selectedApp?.scoreBusinessPlan != null
                            ? selectedApp.scoreBusinessPlan
                            : "Select a score" // fallback if null
                    }
                    defaultValue={
                        selectedApp?.scoreBusinessPlan != null
                            ? selectedApp.scoreBusinessPlan
                            : undefined // no pre-selected value if null
                    }
                    setSelectedValue={(evt) => handleChange("scoreBusinessPlan", evt.value)}
                />
            </div>
            {/* Location Usage */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="locationUsage"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    How are you planning to use our location?
                </label>
                <textarea
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100"
                    defaultValue={selectedApp?.locationUsage}
                    rows="4"
                />
                <label htmlFor="scoreLocationUsage" className="block text-md font-semibold text-gray-800 mb-2 relative">
                    Usage Engagement Score (0-3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowLocationUsageTooltip(true)}
                    >
                        ?
                    </button>
                    {showLocationUsageTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowLocationUsageTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Usage Engagement Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "Little or no information on how the location will be utilized; unclear connection to business needs. No plan."
                                    },
                                    {
                                        score: 1,
                                        text: "Basic idea of how the location will be used, but vague on the details or how it will benefit the business. Coworking with a desire for community and connection. Mostly internal organization engagement."
                                    },
                                    {
                                        score: 2,
                                        text: "Good explanation of location use, but may lack detail on the specific impact or benefits. Coworking with a desire for community and connection with the hope of hosting meetings in our space."
                                    },
                                    {
                                        score: 3,
                                        text: "Desire for full engagement in coworking, community, meetings, and events. Bring people into the space. Clearly outlines specific, strategic ways the location will be used to grow or support the business, with tangible benefits."
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="flex items-start space-x-3 text-gray-800">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS}
                    placeholder={
                        selectedApp?.scoreLocationUsage != null
                            ? selectedApp.scoreLocationUsage
                            : "Select a score" // fallback if null
                    }
                    defaultValue={
                        selectedApp?.scoreLocationUsage != null
                            ? selectedApp.scoreLocationUsage
                            : undefined // no pre-selected value if null
                    }
                    setSelectedValue={(evt) => handleChange("scoreLocationUsage", evt.value)}
                />
            </div>
            {/* Breakeven Point */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="breakevenPoint"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    When Do You Project Your Breakeven Point:
                </label>
                <textarea
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 text-gray-700 bg-gray-100"
                    defaultValue={selectedApp?.breakevenPoint}
                    rows="4"
                />
                <label
                    htmlFor="scoreBreakevenPoint"
                    className="block text-md font-semibold text-gray-800 mb-2 relative"
                >
                    Breakeven Point Score (0-3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowBreakevenPointTooltip(true)}
                    >
                        ?
                    </button>
                    {showBreakevenPointTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowBreakevenPointTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Breakeven Point Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "None. Little to no information on funding or breakeven; plan appears unrealistic."
                                    },
                                    {
                                        score: 1,
                                        text: "Some information on funding or breakeven, but lacks detail or confidence."
                                    },
                                    {
                                        score: 2,
                                        text: "Clear funding sources, but breakeven timeline may be vague or overly optimistic."
                                    },
                                    {
                                        score: 3,
                                        text: "Sustainable Plan. Detailed and realistic explanation of funding sources and a well-justified breakeven timeline."
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS}
                    placeholder={
                        selectedApp?.scoreBreakevenPoint != null
                            ? selectedApp.scoreBreakevenPoint
                            : "Select a score" // fallback if null
                    }
                    defaultValue={
                        selectedApp?.scoreBreakevenPoint != null
                            ? selectedApp.scoreBreakevenPoint
                            : undefined // no pre-selected value if null
                    }
                    setSelectedValue={(evt) => handleChange("scoreBreakevenPoint", evt.value)}
                />
            </div>

            {/* Organization's Top Three Challenges */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="threeChallenges"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    What are your organization's top three challenges or barriers?
                </label>
                <textarea
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 text-gray-700 bg-gray-100"
                    defaultValue={selectedApp?.threeChallenges}
                    rows="4"
                />
                <label
                    htmlFor="scoreChallenges"
                    className="block text-md font-semibold text-gray-800 mb-2 relative"
                >
                    Challenges Score (0-3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowChallengeTooltip(true)}
                    >
                        ?
                    </button>
                    {showChallengeTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowChallengeTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Challenge Removal Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "List none. No clear challenges identified; lacks insight into potential obstacles."
                                    },
                                    {
                                        score: 1,
                                        text: "List one out of three that could potentially be removed by the COhatch ecosystem. Challenges identified, with limited or unclear explanation of their significance."
                                    },
                                    {
                                        score: 2,
                                        text: "List two of three that could potentially be removed by the COhatch ecosystem. Some challenges identified, but not all seem crucial or well-explained."
                                    },
                                    {
                                        score: 3,
                                        text: "Clearly identifies three realistic and critical challenges, with some explanation of how COhatch could potentially address them."
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS}
                    placeholder={
                        selectedApp?.scoreChallenges != null
                            ? selectedApp.scoreChallenges
                            : "Select a score" // fallback if null
                    }
                    defaultValue={
                        selectedApp?.scoreChallenges != null
                            ? selectedApp.scoreChallenges
                            : undefined // no pre-selected value if null
                    }
                    setSelectedValue={(evt) => handleChange("scoreChallenges", evt.value)}
                />
            </div>
            {/* No. of emplyees */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="planHire"
                    className="text-md font-semibold text-gray-800 block mb-2"
                >
                    How Many Employees Do You Have? How Many Do You Plan To Hire In The Next 12/24/36 Months?
                </label>
                <textarea
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 text-gray-700 bg-gray-100"
                    defaultValue={selectedApp?.planHire}
                    rows="4"
                />
                <label
                    htmlFor="scorePlanHire"
                    className="block text-md font-semibold text-gray-800 mb-2 relative mt-2"
                >
                    Number of Employee Score (0-3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowPlanHireTooltip(true)}
                    >
                        ?
                    </button>
                    {showPlanHireTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowPlanHireTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Number of Employee Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "No clear information provided on employees or hiring plans."
                                    },
                                    {
                                        score: 1,
                                        text: "Rough or unclear estimates on employee numbers or hiring plans."
                                    },
                                    {
                                        score: 2,
                                        text: "Employee numbers and growth plan provided, but lacking detail or long-term projections."
                                    },
                                    {
                                        score: 3,
                                        text: "Specific current employee numbers with clear, realistic growth projections over the next 36 months."
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS}
                    placeholder={
                        selectedApp?.scorePlanHire != null
                            ? selectedApp.scorePlanHire
                            : "Select a score" // fallback if null
                    }
                    defaultValue={
                        selectedApp?.scorePlanHire != null
                            ? selectedApp.scorePlanHire
                            : undefined // no pre-selected value if null
                    }
                    setSelectedValue={(evt) => handleChange("scorePlanHire", evt.value)}
                />
            </div>
            {/* # of Team Members Applying for Scholarship */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="teamMembersApplying"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    # of Team Members Applying for Scholarship
                </label>
                <input
                    type="number"
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100"
                    placeholder={selectedApp?.orgAmount}
                />

                {/* # of Team Members Awarded Scholarship */}

                <label
                    htmlFor="awardedMembers"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    # of Team Members Awarded Scholarship (5 max)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowMembersAwardedTooltip(true)}
                    >
                        ?
                    </button>
                    {showMembersAwardedTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowMembersAwardedTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Volunteer Engagement Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 0,
                                        text: "0 - 4 points - DECLINE"
                                    },
                                    {
                                        score: 1,
                                        text: "5 - 7 points (1-2 memberships)"
                                    },
                                    {
                                        score: 2,
                                        text: "15 points - 8 points (up to 3 memberships)"
                                    },
                                    {
                                        score: 3,
                                        text: "16 - 21 points (up to 5 memberships)"
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={orgAmountOPTIONS}
                    placeholder={
                        selectedApp?.awardedMember != null
                            ? selectedApp.awardedMember
                            : selectedApp?.scoreMemAwarded != null
                                ? selectedApp.scoreMemAwarded
                                : "Select a value" // fallback if both are null
                    }
                    defaultValue={
                        selectedApp?.awardedMember != null
                            ? selectedApp.awardedMember
                            : selectedApp?.scoreMemAwarded != null
                                ? selectedApp.scoreMemAwarded
                                : undefined
                    }
                    setSelectedValue={handleAnnualAward}
                />
            </div>
            {/* Overall Application Impact */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label htmlFor="scoreImpact" className="block text-md font-semibold text-gray-800 mb-2 relative">
                    Overall Application Impact Score (0-3 Scale)
                    <button
                        type="button"
                        className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
                        onClick={() => setShowOverallImpactTooltip(true)}
                    >
                        ?
                    </button>
                    {showOverallImpactTooltip && (
                        <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
                            <button
                                type="button"
                                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                                onClick={() => setShowOverallImpactTooltip(false)}
                            >
                                X
                            </button>
                            <h4 className="font-semibold mb-2 text-gray-900">Impact Score Guide:</h4>
                            <ul className="list-none text-gray-700 space-y-4">
                                {[
                                    {
                                        score: 3,
                                        text: "The entire application, including the video, presents a strong, cohesive narrative of the business with clear goals and impact."
                                    },
                                    {
                                        score: 2,
                                        text: "Overall solid application with minor gaps in clarity or cohesiveness."
                                    },
                                    {
                                        score: 1,
                                        text: "Some parts of the application are unclear, incomplete, or inconsistent."
                                    },
                                    {
                                        score: 0,
                                        text: "The application is disorganized or lacks necessary information to form a cohesive picture of the business."
                                    }
                                ].map(({ score, text }) => (
                                    <li key={score} className="text-gray-800 flex items-start space-x-3">
                                        <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                                            {score}
                                        </div>
                                        <p className="text-md font-normal">{text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </label>
                <SelectInput
                    className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
                    options={scorecardOPTIONS}
                    placeholder={
                        selectedApp?.scoreOverallAppImpact != null
                            ? selectedApp.scoreOverallAppImpact
                            : "Select a score" // fallback if null
                    }
                    defaultValue={
                        selectedApp?.scoreOverallAppImpact != null
                            ? selectedApp.scoreOverallAppImpact
                            : undefined // no pre-selected value if null
                    }
                    setSelectedValue={(evt) => handleChange("scoreImpact", evt.value)}
                />
            </div>

            {/* Total Score */}
            <div className="w-full bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="score"
                    className="block text-md font-semibold text-gray-800 mb-2"
                >
                    Total Score (21 maximum)
                </label>
                <input
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100"
                    name="score"
                    id="score"
                    placeholder={
                        (selectedApp?.scoreBusinessVideo || 0) +
                        (selectedApp?.scoreBusinessPlan || 0) +
                        (selectedApp?.scoreLocationUsage || 0) +
                        (selectedApp?.scoreBreakevenPoint || 0) +
                        (selectedApp?.scoreChallenges || 0) +
                        (selectedApp?.scorePlanHire || 0) +
                        (selectedApp?.scoreOverallAppImpact || 0)
                    }
                />
            </div>

            {/* Annual Award */}
            <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
                <label
                    htmlFor="awardAmount"
                    className="text-md font-semibold text-gray-800 block mb-2"
                >
                    Annual Award ($109 x member for 12 months)
                </label>
                <input
                    disabled
                    className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100 text-gray-700"
                    type="text"
                    name="awardAmount"
                    id="awardAmount"
                    value={amount}
                    placeholder={selectedApp?.annualAward}
                />
            </div>
        </div>
    );
};

export default ScorecardBoost;
